import { render, staticRenderFns } from "./prestart.vue?vue&type=template&id=059d15ef&scoped=true&"
import script from "./prestart.vue?vue&type=script&lang=js&"
export * from "./prestart.vue?vue&type=script&lang=js&"
import style0 from "./prestart.vue?vue&type=style&index=0&id=059d15ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059d15ef",
  null
  
)

export default component.exports